// extracted by mini-css-extract-plugin
export default {"topBanner":"topBanner_topBanner__8CVVl","link":"topBanner_link__ymnQR"};